import './HeatingSettings.css';
import NumericInput from './NumericInput.js';
import React from 'react';

export function ConsumptionControlTable({ services, metadata, onToggleEnabled, onControlToggle, onOverrideToggle, onHoursChange, onOverrideTypeChange, onPriceBasedHoursChange, onCurrentAChange }) {
  if (!services || services.length === 0) {
    return <div>No consumption control services configured.</div>;
  }

  if (!metadata) {
    return <div>Missing metadata for consumption control configuration.</div>;
  }
  
  const { rank_types, override_types } = metadata;

  // New function to handle price-based hours changes
  const handlePriceBasedHoursChange = (serviceId, priceIndex, value) => {
    if (onPriceBasedHoursChange) {
      onPriceBasedHoursChange(serviceId, priceIndex, value);
    }
  };

  return (
    <div className="profile-tables-container">
      {services.map((service) => (
        <div key={service.id} className="profile-table">
          <h3>{service.name}</h3>
          
          <div style={{ marginBottom: '15px' }}>
            <label style={{ marginRight: '20px' }}>
              Enabled:
              <input
                type="checkbox"
                checked={service.enabled}
                onChange={(e) => onToggleEnabled(service.id, 'enabled', e.target.checked)}
                style={{ marginLeft: '8px' }}
              />
            </label>
            <span>Actor name: {service.actor_name}</span>
          </div>
          
    
          {/* Control Settings */}
          <table className="profile-table">
            <thead>
              <tr>
                <th colSpan="2">Control Settings</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Enabled</td>
                <td>
                  <input
                    type="checkbox"
                    checked={service.controller.enabled}
                    onChange={(e) => onControlToggle(service.id, e.target.checked)}
                  />
                </td>
              </tr>
              <tr>
                <td>Active period</td>
                <td>{rank_types[service.controller.rank_type]}</td>
              </tr>
                {service.actor && service.actor.currentA !== undefined && (
                  <tr>
                        <td>Max current (A)</td>
                        <td>
                          <NumericInput
                            value={service.actor.currentA}
                            onChange={(value) => onCurrentAChange(service.id, value)}
                            min={0}
                            max={32}
                            step={1}
                          />
                        </td>
                    </tr>
                )}
              <tr>
                <td>{service.controller.type === 'fixed_hours' ? 'Enable for number of lowest spot price hours' : 'Price ranges'}</td>
                <td>
                  {service.controller.type === 'fixed_hours' ? (
                    <NumericInput
                      value={service.controller.hours}
                      onChange={(value) => onHoursChange(service.id, 'controller', value)}
                      min={0}
                      max={24}
                      step={1}
                    />
                  ) : (
                    <span>Enable for number of lowest spot price hours</span>
                  )}
                </td>
              </tr>
              
              {service.controller.type === 'price_based' && Array.isArray(service.controller.hours) && (
                <>
                  {service.controller.hours.map((priceConfig, index) => (
                    <tr key={`price-range-${index}`}>
                      <td>
                        {priceConfig.max_price === 999 
                          ? `Range > ${service.controller.hours[index - 1]?.max_price || 0}`
                          : index === 0 
                            ? `Range ≤ ${priceConfig.max_price}`
                            : `Range ${service.controller.hours[index - 1]?.max_price} - ${priceConfig.max_price}`
                        }
                      </td>
                      <td>
                        <NumericInput
                          value={priceConfig.hours}
                          onChange={(value) => handlePriceBasedHoursChange(service.id, index, value)}
                          min={0}
                          max={24}
                          step={1}
                        />
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
          
          {/* Override Settings */}
          <table className="profile-table" style={{ marginTop: '0px' }}>
            <thead>
              <tr>
                <th colSpan="3">Override Settings</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Enabled</td>
                <td colSpan="2">
                  <input
                    type="checkbox"
                    checked={service.override.enabled}
                    onChange={(e) => onOverrideToggle(service.id, e.target.checked)}
                  />
                </td>
              </tr>
              <tr>
                <td>Override type</td>
                <td>
                  <select 
                    value={service.override.type}
                    onChange={(e) => onOverrideTypeChange(service.id, e.target.value)}
                  >
                    {Object.entries(override_types).map(([type, label]) => (
                      <option key={type} value={type}>
                        {label}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  {service.override.type === 'until_end_of_day' ? (
                    <span className="inactive-field">N/A</span>
                  ) : (
                    <NumericInput
                      value={service.override.hours}
                      onChange={(value) => onHoursChange(service.id, 'override', value)}
                      min={0}
                      max={24}
                      step={1}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
